module.exports = __webpack_public_path__ + "static/img/Zoo.867ce39.png";